const phoneNumberRegex = /(\d{0,3})(\d{0,3})(\d{0,4})/;

export const maskPhoneNumber = (phoneNumber: string) => {
    // remove non digits and split into three groups
    const matched = phoneNumber.replace(/\D/g, '').match(phoneNumberRegex) || [];

    return matched[2] === '' ? matched[1] : '(' + matched[1] + ') ' + matched[2] + (matched[3] ? '-' + matched[3] : '');
};

export const unmaskPhoneNumber = (maskedPhoneNumber: string) => {
    // return only digits
    return maskedPhoneNumber.replace(/\D+/g, '');
};

export const isEnvironmentProd = (environment: string) => {
    return !!environment && !!environment.match(/PROD/g);
};

export const maskEmail = (email: string): string => {
    // leave first character of username and domain, replace the rest with *
    // leave the extension unchanged
    return email.replace(/(\w)([^@]*)(@)(\w)([^.]*)(\..+)/, (substring, p1, p2, p3, p4, p5, p6) => {
        return p1 + p2.replace(/./g, '*') + p3 + p4 + p5.replace(/./g, '*') + p6;
    });
};
